// eslint-disable-next-line max-classes-per-file
import { Uuid } from '@ftr/contracts/type/shared'
import { CartItem } from './cart.model'

export class SanitiseCartItems {
  static readonly type = '[Cart] Sanitise Item'
}

export class AddCartItems {
  static readonly type = '[Cart] Add Items'
  constructor(public readonly items: CartItem[]) {}
}

export class RemoveCartItems {
  static readonly type = '[Cart] Remove Items'
  constructor(public readonly itemIds: Uuid[]) {}
}

export class UpdateCartItem {
  static readonly type = '[Cart] Update Item'
  constructor(
    public readonly itemId: Uuid,
    public readonly updates: Partial<Omit<CartItem, 'id'>>,
  ) {}
}

export class ClearCartItems {
  static readonly type = '[Cart] Clear Items'
}

export class SetCartCourtSystem {
  static readonly type = '[Cart] Set Court System Id'
  constructor(
    public readonly courtSystemId: Uuid,
    public readonly courtSystemName: string,
  ) {}
}
